const Component = () => import('./Sale');

// eslint-disable-next-line import/prefer-default-export
export { Component };
